export const ALERT_ICON = "PaymentLogos/paymentIcons/error";
